// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3_2_f","buttons":"SendReceipts_buttons__28Rrc","email":"SendReceipts_email__1lE7X","bookApptTitle":"SendReceipts_bookApptTitle__38LZ2"};